import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import * as serviceWorker from './serviceWorker';
import { HashRouter } from 'react-router-dom'
import ScrollToTop from './ScrollToTop'

import GlobalStore from './stores/GlobalStore'
import load from './stores/load'
import { ToastProvider } from './contexts/ToastContext'
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})


ReactDOM.render(
  <QueryClientProvider client={queryClient} contextSharing>
    <GlobalStore load={load}>
      <ToastProvider>
        <HashRouter>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </HashRouter>
      </ToastProvider>
    </GlobalStore>
  </QueryClientProvider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
